import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  createFlow,
  deleteFlow,
  getFlow,
  listFlows,
  testFlow,
  updateFlow,
  type CreateFlowRequest,
  type TestFlowRequest,
  type UpdateFlowRequest,
} from '@/services/flowsService';

export function useFlows() {
  return useQuery({
    queryKey: ['flows'],
    queryFn: async () => {
      const res = await listFlows();
      return res.data;
    },
    enabled: true,
  });
}

export function useFlow(flowId?: string) {
  return useQuery({
    queryKey: ['flow', flowId],
    queryFn: async () => {
      if (!flowId) throw new Error('flowId is required');
      const res = await getFlow(flowId);
      return res.data;
    },
    enabled: Boolean(flowId),
  });
}

export function useCreateFlow() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (payload: CreateFlowRequest) => {
      const res = await createFlow(payload);
      return res.data;
    },
    onSuccess: () => {
      qc.invalidateQueries(['flows']);
    },
  });
}

export function useUpdateFlow(flowId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (payload: UpdateFlowRequest) => {
      const res = await updateFlow(flowId, payload);
      return res.data;
    },
    onSuccess: () => {
      qc.invalidateQueries(['flows']);
      qc.invalidateQueries(['flow', flowId]);
    },
  });
}

export function useDeleteFlow() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (flowId: string) => {
      const res = await deleteFlow(flowId);
      return res.data;
    },
    onSuccess: () => {
      qc.invalidateQueries(['flows']);
    },
  });
}

export function useTestFlow(flowId: string) {
  return useMutation({
    mutationFn: async (payload: TestFlowRequest) => {
      const res = await testFlow(flowId, payload);
      return res.data;
    },
  });
}
